export default __webpack_public_path__ + "static/media/beaver-step-1.52da9d10.svg";